import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { DropdownButton, MenuItem, Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['partnertypes'])
export default class PartnerTypes extends Component {

  constructor(props) {
    super(props)

    this.props.partnertypes.loadAllPartnerTypes()

    this.props.partnertypes.loadAllPartnerCompanies()
  }

  newPartnerType(row) {
    this.props.partnertypes.newPartnerType(row)
  }

  updatePartnerType(row, cellText, cellValue) {
    this.props.partnertypes.updatePartnerType(row.id, row)
  }

  deletePartnerType(id) {
    if (confirm('Are you sure you want to delete this Partner Type?')) {
      this.props.partnertypes.deletePartnerType(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deletePartnerType(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newPartnerType.bind(this)
    }

    const ddOptions = this.props.partnertypes.partnerCompanies.map((option) => {
      return option.name
    })

    const partnerTypesTable = (
      <BootstrapTable
          data={ this.props.partnertypes.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updatePartnerType.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="partnerCompanyName" editable={{ type: 'select', options: { values: ddOptions } }}>Partner Company</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    //<TableHeaderColumn width="50" dataField="partnerCompanyName" customEditor={{ getElement: createDropDown }}>Partner Companies</TableHeaderColumn>

    return (
      <div>
        <Collapsible title="Partner Types" content={ partnerTypesTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/partnertypes.js